<template>
  <el-table stripe :data="cows" height="yes" class="my-table" border highlight-current-row @current-change="handleCurrentChange"
    :default-sort="{prop: 'estrus.is_during', order: 'descending'}" :row-class-name="cssMethod">
    <el-table-column type="expand">
      <template slot-scope="props">
        <div>
          <div style="float: left">
            <p>Imie: {{ props.row.name }}</p>
            <p>Data urodzenia: {{ new Date(props.row.birth_date).toLocaleDateString() }}</p>
            <p>Numer matki: {{ props.row.mothers_number }} </p>
            <p>Numer ojca: {{ props.row.fathers_number }}</p>
            <p>Sucha: {{props.row.dry === false ? "Nie" : "Tak" }}</p>
            <p>Cielna: {{ props.row.with_calf === false ? "Nie" : "Tak" }}</p>
          </div>
          <div style="float: right">
            <p>Ostatnia inseminacja: {{ getDateOrDash(props.row.date_sumary.insemination) }}
            </p>
            <p>Powtórka: {{  getDateOrDash(props.row.date_sumary.repeat) }}</p>
            <p>Zasuszać: {{  getDateOrDash(props.row.date_sumary.drying) }}</p>
            <p>Wycielenie: {{  getDateOrDash(props.row.date_sumary.claving) }}</p>
          </div>
          <div style="clear: both"></div>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="Numer" prop="number" sortable :sort-method="sortNumber" min-width="170">
    </el-table-column>
    <el-table-column label="Dni D" prop="stats.milking_days" min-width="100">
    </el-table-column>
    <el-table-column label="% T" prop="stats.fat_percent" sortable>
    </el-table-column>
    <el-table-column label="% B" prop="stats.protein_percent" sortable>
    </el-table-column>
    <el-table-column label="Kom S" prop="stats.somatic_cells" >
    </el-table-column>
    <el-table-column label="M" prop="stats.urea" sortable>
    </el-table-column>
    <el-table-column label="ML" prop="stats.milk_kilograms" sortable>
    </el-table-column>
    <el-table-column label="Wiek" prop="age">
    </el-table-column>
    <el-table-column label="Grupa" prop="group" min-width="110" :filters="groupsForFilter" :filter-method="filterGroups">
    </el-table-column>
    <el-table-column label="W" prop="estrus.is_during" sortable width="80">
    </el-table-column>
  </el-table>
</template>

<script>
import bus from "@/bus";
import axios from "axios";
import { serverAddress } from "../config";

export default {
  props: ["cows", "groups"],
  date: function() {
    return {};
  },
  computed: {
    groupsForFilter: function() {
      var groupsForF = [];
      for (var group of this.groups) {
        groupsForF.push({
          text: group.name,
          value: group.name
        });
      }
      return groupsForF;
    }
  },
  methods: {
    handleCurrentChange(value) {
      this.currentRow = value;
      this.lastInseminationDates = [];
      bus.$emit("cow-selected", value);
      // this.getLastInsemination(this.currentRow);
    },
    getLastInsemination(row) {
      if (row === null) {
        return;
      }
      row.lastInseminationDates = {};
      axios
        .get(
          serverAddress +
            "/api/cattle/female/" +
            row.number +
            "/lastinsemination",
          {
            auth: {
              username: "foo",
              password: "bar"
            }
          }
        )
        .then(
          function(response) {
            row.lastInseminationDates = response.data;
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    },
    getLastInseminationDates(index) {
      console.log(this.lastInseminationDates);
      return "dipa"; //this.lastInseminationDates[index]
    },
    filterByNumber(value, row) {
      return true;
    },
    booleanToWord(flag) {
      if (flag) {
        return "Tak";
      }
      return "Nie";
    },
    estrusFormater(row, column) {
      console.log("row:", row);
      return row[column.property].is_during === true ? "Tak" : "";
    },
    estrusSortMethod(x, y) {
      return y.estrus.is_during - x.estrus.is_during;
    },
    cssMethod(row, index) {
      if (row.row.estrus.is_during != "") {
        return "estrus-row-mark";
      }
      return "";
    },
    filterGroups(value, row) {
      console.log("row:", row);
      return row.group === value;
    },
    sortNumber(n1, n2) {
      return parseInt(n1.number.slice(-5)) - parseInt(n2.number.slice(-5))
    },
    getDateOrDash(rawDate) {

      return rawDate === "0001-01-01T00:00:00Z" ? "-" : new Date(rawDate).toLocaleDateString(); 
    }
  }
};
</script>

<style>

</style>
